import { useEffect, useRef } from 'react';

import type { AssistantMessage } from '../../types/assistant';

import { AssistantBubble } from './AssistantBubble';
import { AssistantEmpty } from './AssistantEmpty';
import { AssistantError } from './AssistantError';

interface Props {
  messages: AssistantMessage[];
  error: string | null;
}

export function AssistantMessageList({ messages, error }: Props) {
  const endRef = useRef<HTMLDivElement | null>(null);

  // Stick to bottom on append — same behaviour as the transcript Virtuoso
  // followOutput. Plain scrollIntoView is enough here: the assistant chat
  // is bounded (one practitioner, dozens of turns max), not 800-segment
  // territory.
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [messages, error]);

  if (messages.length === 0 && !error) {
    return <AssistantEmpty />;
  }
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto px-3 py-3">
      {messages.map((m) => (
        <AssistantBubble key={m.id} message={m} />
      ))}
      {error ? <AssistantError message={error} /> : null}
      <div ref={endRef} />
    </div>
  );
}
